import { Component, Input, OnInit, AfterViewInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Step2 } from '../../../../shared/models/component-messages/diveIN/step2';
import { RadioCheckBoxEnum } from '../../../common/radio.checkbox.enums';
import { CTRL_202 } from '../../../validators/202/ctrl202';
import { CTRL_203 } from '../../../validators/203/ctrl203';
import { CTRL_204 } from '../../../validators/204/ctrl204';
import { CTRL_205 } from '../../../validators/205/ctrl205';
import { CTRL_499 } from '../../../validators/499/ctrl499';
import { Description } from '../models/Description';
import { TypeAnn_DIVER_G1 } from '../models/TypeAnn_DIVER_G1';
import { DivINControlNames } from '../services/DivINControleNames';
import { CTRL_268 } from '../../../validators/268/ctrl268';
import { CTRL_176 } from '../../../validators/176/ctrl176';
import { AvisDataTransferService } from '../../../../shared/services/avis-data-transfer.service';

@Component({
  selector: 'app-description',
  templateUrl: './description.component.html'
})
export class DescriptionComponent implements OnInit, AfterViewInit {

  @Input() uid = '';
  public current_uid = 'Description';
  @Input() parentForm: FormGroup;
  @Input() description: Description;
  @Input() disabled: boolean;
  @Input() initial: TypeAnn_DIVER_G1;
  natureMarche_uid = 'descriptionMarche';

  public rg2 = CTRL_268.id + '_2';
  public rg3 = CTRL_268.id + '_3';
  public rg4 = CTRL_268.id + '_4';
  public rg5 = CTRL_202.id + '_1';
  public rg6 = CTRL_203.id + '_2';
  public rg7 = CTRL_204.id + '_3';
  public rg8 = CTRL_205.id + '_4';
  public rg9 = CTRL_499.id + '_1';
  public rg10 = CTRL_176.id + '_1';
  public rg11 = CTRL_176.id + '_2';
  public rg12 = CTRL_176.id + '_3';

  public step2 = new Step2();


  public readonly travauxValue = RadioCheckBoxEnum.travauxValue;
	public readonly fournituresValue = RadioCheckBoxEnum.fournituresValue;
	public readonly servicesValue = RadioCheckBoxEnum.servicesValue;

  public radioButtonValue: string;
	public radioButtonCtrlName: string;
  estCbChecked: boolean;

  constructor(private avisDataTransferService: AvisDataTransferService) {
  }

  public ngOnInit() {
    this.parentForm.addControl(this.getStepId() + this.rg9, new FormControl({ rgCtrls: DivINControlNames.getCtrl_499Names_json() }));
		if (this.description.descriptionMarche?.natureMarche.fournitures === RadioCheckBoxEnum.emptyValue) {
			this.radioButtonValue = this.fournituresValue;
		} else if (this.description.descriptionMarche?.natureMarche.services === RadioCheckBoxEnum.emptyValue) {
			this.radioButtonValue = this.servicesValue;
		} else {
			this.radioButtonValue = this.travauxValue;
		}
		this.radioButtonCtrlName = this.getUid() + '_SepAtt_travaux';
    this.cbChecked()
  }

  ngAfterViewInit() {
    this.researchFormOnChangeDetecte();
  }

  researchFormOnChangeDetecte(){
    const controlName = this.getUid() + '_SepAtt_lieuExecutionCB';
    const control = this.parentForm.get(controlName);
    if (control) {
      control.valueChanges.subscribe(value => {
        this.cbChecked()
      });
    }
  }

  public getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }

  getUidNatureMarche(){
    return this.uid + '_SepSep_' + this.natureMarche_uid;
  }

  isTravaux(){
		return this.parentForm.controls[this.getUidNatureMarche() + '_SepAtt_travaux']?.value;
  }

  isFournitures(){
		return this.parentForm.controls[this.getUidNatureMarche() + '_SepAtt_fournitures']?.value;
  }

  isServices(){
		return this.parentForm.controls[this.getUidNatureMarche() + '_SepAtt_services']?.value;
  }

  cbChecked(){
    this.estCbChecked = this.parentForm.controls[this.getUid() + '_SepAtt_lieuExecutionCB'] ?
                        this.parentForm.controls[this.getUid() + '_SepAtt_lieuExecutionCB'].value :
                        this.avisDataTransferService.getFormData().jsonSaisieFormulaire.ann.divers.initial.description.isLieuExecutionLivraison;
    if (this.estCbChecked) {
      this.parentForm.addControl(this.getStepId() + this.rg4, new FormControl({ rgCtrls: this.getCtrl_268_3Names_json() }));
      this.parentForm.addControl(this.getStepId() + this.rg12, new FormControl({ rgCtrls: DivINControlNames.getCtrl_176_3Names_json() }));
    } else {
      this.parentForm.addControl(this.getStepId() + this.rg2, new FormControl({ rgCtrls: this.getCtrl_268_1Names_json() }));
      this.parentForm.addControl(this.getStepId() + this.rg3, new FormControl({ rgCtrls: this.getCtrl_268_2Names_json() }));
      this.parentForm.addControl(this.getStepId() + this.rg5, new FormControl({ rgCtrls: DivINControlNames.getCtrl_202Names_json() }));
      this.parentForm.addControl(this.getStepId() + this.rg6, new FormControl({ rgCtrls: DivINControlNames.getCtrl_203Names_json() }));
      this.parentForm.addControl(this.getStepId() + this.rg7, new FormControl({ rgCtrls: DivINControlNames.getCtrl_204Names_json() }));
      this.parentForm.addControl(this.getStepId() + this.rg8, new FormControl({ rgCtrls: DivINControlNames.getCtrl_205Names_json() }));
      this.parentForm.addControl(this.getStepId() + this.rg10, new FormControl({ rgCtrls: DivINControlNames.getCtrl_176_1Names_json() }));
      this.parentForm.addControl(this.getStepId() + this.rg11, new FormControl({ rgCtrls: DivINControlNames.getCtrl_176_2Names_json() }));
    }
  }

  getUidObjet(){
		return this.getUid() + '_SepSep_ChampsLibresTexte';
	}

	getUidTxtLibre(){
		return this.getUidObjet() + '_SepSep_ChampLibreGroup';
	}

	getUidIntLibre(){
		return this.getUidObjet() + '_SepSep_IntituleLibreGroup';
	}

  getStepId() {
    return this.uid.substring(0, this.uid.indexOf("SepSep"));
  }

  private getCtrl_268_1Names_json(): any {
    const deptPub = '_SepSep_TypeIndexation_SepSep_TypeDept_SepAtt_deptPub';
    const cp = '_SepSep_TypeAnn_DIVER_G1_SepSep_Description_SepSep_TypeLieu_SepAtt_cp';
    return { firstChamp: deptPub, secondChamp: cp };
  }

  private getCtrl_268_2Names_json(): any {
    const deptPub = '_SepSep_TypeIndexation_SepSep_TypeDept_SepAtt_deptPub';
    const cp = 'lieuLivraison_SepSep_TypeAnn_DIVER_G1_SepSep_Description_SepSep_TypeLieu_SepAtt_cp';
    return { firstChamp: deptPub, secondChamp: cp };
  }

  private getCtrl_268_3Names_json(): any {
    const deptPub = '_SepSep_TypeIndexation_SepSep_TypeDept_SepAtt_deptPub';
    const cp = 'lieuExecutionLivraison_SepSep_TypeAnn_DIVER_G1_SepSep_Description_SepSep_TypeLieu_SepAtt_cp';
    return { firstChamp: deptPub, secondChamp: cp };
  }
}

